import { styled } from '@mui/system';
import { Switch, Typography } from '@mui/material';
import { FC } from 'react';

const SubSectionContainer = styled('div')({
  padding: '8px 24px 8px',
  '&.promotional': {
    marginLeft: '16px'
  }
});

const SubSection = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between'
});

const DisplayText = styled(Typography)({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#000000'
});

const CustomSwitch = styled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#008A06'
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#2DE13F'
  }
});

interface CommunicationSubSectionProps {
  text: string;
  isChecked: boolean;
  onChange: (value: boolean) => void;
  isPromotionalComSubSection?: boolean;
  className?: string;
}

const CommunicationSubSection: FC<CommunicationSubSectionProps> = (props) => {
  const { text, isChecked, onChange, className, isPromotionalComSubSection } = props;

  return (
    <SubSectionContainer className={`${className} ${isPromotionalComSubSection ? 'promotional' : ''}`}>
      <SubSection className='sub-section'>
        <DisplayText className='display-text' variant="body2">{text}</DisplayText>
        <CustomSwitch checked={isChecked} onChange={(e, checked) => onChange(checked)} />
      </SubSection>
    </SubSectionContainer>
  );
};

export default CommunicationSubSection;
